// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames not based on template
	if (chunkId === 257) return "static/chunks/257-791cb5cb679d9302.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"287":"4c0d546d266563d7","631":"573c50959eafd544"}[chunkId] + ".js";
};